import { create } from 'zustand';

/**
 * Who is signed in and what they may do.
 *
 * The permission set comes from the server on every session read, and the UI
 * only uses it to decide what to draw. Every action is checked server-side
 * again — hiding a button is presentation, not security.
 */
export const useSession = create((set, get) => ({
  status: 'unknown',
  admin: null,
  permissions: new Set(),

  signedIn: (admin, permissions = []) =>
    set({ status: 'authenticated', admin, permissions: new Set(permissions) }),

  signedOut: () => set({ status: 'guest', admin: null, permissions: new Set() }),

  can: (module, action) => {
    const state = get();
    if (state.admin?.role === 'superadmin') return true;
    return state.permissions.has(`${module}:${action}`);
  },
}));

export default useSession;
